// File: components/scheduleSection/ScheduleSection.jsx

import React from "react";
import "./ScheduleSection.css";
import { useNavigate } from "react-router-dom";

import leftImage from "../../Assets/images/books3.jpeg";
import rightImage from "../../Assets/images/book3.jpeg";

export default function ScheduleSection() {

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/contact-us");
  };

  return (

    <section className="schedule-section">

      <div className="schedule-container">

        {/* Top Grid */}
        <div className="schedule-grid">

          {/* Left Image Card */}
          <div className="schedule-image-card">

            <img
              src={leftImage}
              alt="Publishing Experience"
              className="schedule-image"
            />

          </div>

          {/* Right Testimonial Card */}
          <div className="schedule-testimonial-card">

            {/* Author Image */}
            <div className="schedule-author-image-wrapper">

              <img
                src={rightImage}
                alt="Author"
                className="schedule-author-image"
              />

            </div>

            {/* Author Content */}
            <div className="schedule-author-content">

              <p className="schedule-quote">
                “Personal experience and taking responsibility are the greatest teachers in the world. In the current world scenario, a multitude of varying motivational theories will emerge and reach worldwide recognition, all based of sharing of personal experiences. ”
              </p>

              <h4>
                — Raj Mohan.
              </h4>

              <span>
                Author
              </span>

            </div>

          </div>

        </div>

        {/* Button */}
        <div className="schedule-btn-wrapper">

          <button
            className="schedule-btn"
            onClick={handleNavigate}
          >
            Schedule A Meeting
          </button>

        </div>

      </div>

    </section>

  );
}